var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockMeterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.5,0C21.3,0,0,21.3,0,47.5C0,55.8,2.2,64,6.3,71.2C7,72.4,8.2,73,9.5,73c0.6,0,1.2-0.2,1.8-0.5l8.3-4.7 c1.7-1,2.3-3.2,1.3-5c-1-1.7-3.2-2.3-5-1.3l-5,2.9C9,60.2,7.8,55.7,7.4,51.1h5.7c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6H7.5 c0.4-4.7,1.7-9.1,3.6-13.2l4.9,2.8c0.6,0.3,1.2,0.5,1.8,0.5c1.3,0,2.5-0.7,3.2-1.8c1-1.7,0.4-4-1.3-5l-4.9-2.8 c2.7-3.8,5.9-7,9.7-9.7l2.8,4.9c0.7,1.2,1.9,1.8,3.2,1.8c0.6,0,1.2-0.2,1.8-0.5c1.7-1,2.3-3.2,1.3-5L30.8,11 c4.1-1.9,8.5-3.1,13.2-3.6v5.7c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6V7.4c4.7,0.4,9.1,1.7,13.2,3.6l-2.9,4.9c-1,1.7-0.4,4,1.3,5 c0.6,0.3,1.2,0.5,1.8,0.5c1.3,0,2.5-0.7,3.2-1.8l2.8-4.9c3.8,2.7,7,5.9,9.7,9.7l-4.9,2.8c-1.7,1-2.3,3.2-1.3,5 c0.7,1.2,1.9,1.8,3.2,1.8c0.6,0,1.2-0.2,1.8-0.5l4.9-2.8c1.9,4.1,3.1,8.5,3.6,13.2h-5.7c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h5.6 c-0.4,4.6-1.6,9.1-3.5,13.3l-5-2.9c-1.7-1-4-0.4-5,1.3c-1,1.7-0.4,4,1.3,5l8.3,4.7c1.7,1,3.9,0.4,5-1.3C92.8,64,95,55.8,95,47.4 C95,21.3,73.7,0,47.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.5,30.4l-9.8,9.1c-1-0.4-2-0.6-3.2-0.6c-4.7,0-8.6,3.8-8.6,8.6s3.8,8.6,8.6,8.6s8.6-3.8,8.6-8.6             c0-0.9-0.2-1.8-0.4-2.6l9.8-9.2c1.5-1.4,1.5-3.7,0.2-5.1C64.3,29.1,62,29,60.5,30.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockMeterIcon);
export default __webpack_public_path__ + "static/media/block-meter-icon.c7b9fce9403018e6631815e73a12d71d.svg";
export { ForwardRef as ReactComponent };